import _ from 'lodash';

import * as messages from '../constants/messages';
import { validations, student, parentConstraints } from './constraints';

export const studentValidation = (values) => {
  const errors = validations(student)(values);
  const parents = values.get('parents');
  if (!parents || parents.isEmpty()) {
    errors.parents = { _error: messages.STUDENT_PARENTS_PRESENCE };
  } else {
    const parentsArrayErrors = [];
    parents.forEach((parent, parentIndex) => {
      const parentErrors = validations(parentConstraints)(parent);
      if (parentErrors) {
        parentsArrayErrors[parentIndex] = parentErrors;
      }
    });
    if (!_.isEmpty(parentsArrayErrors)) {
      errors.parents = parentsArrayErrors;
    }
  }
  return errors;
};



// WEBPACK FOOTER //
// ./src/utils/validations.js